import { useEffect } from "preact/hooks";
import type { UiPresetStyles } from "../config/presets";

export function useExternalAssets(styles: UiPresetStyles) {
	useEffect(() => {
		const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
		if (siteKey && !document.querySelector('script[src*="recaptcha/api.js"]')) {
			const script = document.createElement("script");
			script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
			script.async = true;
			script.defer = true;
			document.head.appendChild(script);
		}
	}, []);

	useEffect(() => {
		if (!styles.requiresTypekit) {
			return;
		}

		const existing = document.getElementById("maia-typekit-fonts");
		if (existing) {
			return;
		}

		const link = document.createElement("link");
		link.id = "maia-typekit-fonts";
		link.rel = "stylesheet";
		link.href = "https://use.typekit.net/zth5wcr.css";
		document.head.appendChild(link);
	}, [styles.requiresTypekit]);
}
